import { SET_EMP_DETAILDATA } from "../actions";

const empdetaildata = (state = [], action) => {
  switch (action.type) {
    case SET_EMP_DETAILDATA:
      return [...action.value];
    default:
      return state;
  }
};

export default empdetaildata;
